import React from 'react'
import { withTranslation } from 'react-i18next'
import NotificationIcon from 'app/components/SVGS/NotificationIcon'

import './styles.scss'

const bc = 'notifications-empty-list'

const NotificationsEmptyList = ({ t }) => (
  <div className={bc}>
    <div className={`${bc}__icon`}>{React.createElement(NotificationIcon, { height: 104, width: 83 })}</div>
    <div className={`${bc}__message`}>
      <div className={`${bc}__title`}>{t('No new notifications')}</div>
      <div className={`${bc}__text`}>{t('You’re all caught up!')}</div>
    </div>
  </div>
)

export default withTranslation('common')(NotificationsEmptyList)
